module.exports = __webpack_public_path__ + "img/eoc-four-points-office-building-2.70f5403a.jpg";